<template>
  <CButton
    v-if="isSuperAdmin"
    v-c-tooltip="tooltip"
    color="info"
    variant="outline"
    size="sm"
    :class="compact ? 'impersonate-btn--compact' : 'mr-2'"
    :href="clientUiUrl"
    target="_blank"
    rel="noopener noreferrer"
  >
    <CIcon
      :name="compact ? 'cil-user' : 'cil-external-link'"
      size="sm"
      :class="compact ? '' : 'mr-1'"
    />
    <template v-if="!compact">
      Open in Client UI (impersonate)
    </template>
  </CButton>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OpenInClientUiButton',

  props: {
    accountId: {
      type: String,
      required: true
    },

    compact: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('auth', ['isSuperAdmin']),

    clientUiUrl() {
      const baseUrl = (this.CLIENT_SIDE_BASE_URL || '').replace(/\/+$/, '')
      return `${baseUrl}/?impersonateAccountId=${encodeURIComponent(this.accountId)}`
    },

    tooltip() {
      if (this.compact) {
        return 'Impersonate: open this account in Client UI'
      }

      return 'Opens this account in Client UI as an admin. Your changes there are logged as admin activity. To receive this account\'s email notifications instead, add yourself under Users.'
    }
  }
}
</script>

<style scoped>
.impersonate-btn--compact {
  padding: 0.1rem 0.3rem;
  line-height: 1;
}
</style>
